import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { plotBackground } from "../../../config/colors";
import { TostadorFetching } from "../../../class/fetchTostador";
import { useDate } from "../../../hooks/useDate";
import "../Tostador.css";

export default function PerfilEnfriador1() {
  // Objeto inicial de la peticion
  const initialFetch = new TostadorFetching().setIdSeccion(4).setSecuencia(29);
  const enfriador2 = new TostadorFetching().setIdSeccion(4).setSecuencia(28);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [potencia, setPotencia] = useState(defaultObject);
  //const [temperaturaSalida, setTemperaturaSalida] = useState(defaultObject);
  const [factorUa, setFactorUa] = useState(defaultObject);

  const [potencia2, setPotencia2] = useState(defaultObject);
  const [factorUa2, setFactorUa2] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      const arrEnfriador2 = await getValoresPeriodo(enfriador2);

      if (arrEnfriador2.data) {
        populateFactorUa2(arrEnfriador2.data);
        populatePotencia2(arrEnfriador2.data);
      }

      if (data) {
        populatePotencia(data);
        // populateTemperaturaSalida(data);
        populateFactorUa(data);
        // usamos el hook de fecha para guardar los datos del periodo
        setDateHook(data, "Potencia Enfriador 1");
      }
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populatePotencia(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Potencia Enfriador 1"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setPotencia({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePotencia2(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Potencia Enfriador 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setPotencia2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  /*
  function populateTemperaturaSalida(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida Enfriador 1"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTemperaturaSalida({
      fecha: arrFechas,
      value: arrValues,
    });
  }*/

  function populateFactorUa(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Factor UA Enfriador 1"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFactorUa({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateFactorUa2(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Factor UA Enfriador 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFactorUa2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Enfriadores de Calcina"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Potencia Enfriador 1 --------------------------------------- */}
            <Chart.Line
              name="Potencia Enfriador 1"
              data={potencia.value}
              yAxis={0}
            />

            {/** -------------------------------- Factor UA Enfriador 1 --------------------------------------- */}
            <Chart.Line
              name="Factor UA Enfriador 1"
              data={factorUa.value}
              yAxis={1}
            />

            {/** -------------------------------- ENFRIADOR 2 --------------------------------------- */}

            {/** -------------------------------- Potencia Enfriador 2 --------------------------------------- */}
            <Chart.Line
              name="Potencia Enfriador 2"
              data={potencia2.value}
              yAxis={0}
            />

            {/** -------------------------------- Factor UA Enfriador 2 --------------------------------------- */}
            <Chart.Line
              name="Factor UA Enfriador 2"
              data={factorUa2.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={potencia.fecha} />

            <Chart.YAxis
              labelSuffix=" kW"
              title="Potencia, kW"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=" kW/°C"
              title="Factor UA,  kW/°C"
              lineWidth={2}
              lineColor="white"
              opposite={true}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
